import { INE_CALENDAR_SEARCH_START_LOADING, INE_CALENDAR_SEARCH_END_LOADING, INE_CALENDAR_SEARCH_LOADED, SET_INE_CALENDAR_FILTER } from "../constants/IneCalendarConstants";

const initialState = {
    loading: false,
    fbo: null,
    filter: {
        search: ""
    }
};

const IneCalendarReducer = (state = initialState, action) => {
    switch(action.type) {
        case INE_CALENDAR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case INE_CALENDAR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case INE_CALENDAR_SEARCH_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        case SET_INE_CALENDAR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        default:
            return state;
    }
}

export default IneCalendarReducer;
